module.exports = __webpack_public_path__ + "static/img/7.11f292a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/7.png
// module id = qpyM
// module chunks = 0